import { entities, plainToInstance, selectors } from "@fraction/shared";
import type { ChecklistApp } from "../api/types";

export function selectChecklistApplication(application: any): ChecklistApp {
  if (!application) {
    return application;
  }

  // Fast path: application data is already deserialized at the API boundary
  // (FractionClient.getApplication/getApplications) and optimistic cache writes
  // re-normalize on write (updateApplicationInFetchCache), so the value reaching
  // here is normally already an Application instance. The expensive part is
  // `plainToInstance` over the whole graph, and react-query runs `select` once per
  // subscriber per read — with ~90 useApplicationAuthed subscribers that was the
  // dominant render cost. Skip the re-deserialize for instances and only refresh
  // the cheap derived `syntheticStatus` (its inputs can change via cache writes).
  // Returning the live instance — rather than a cached copy, as the previous
  // WeakMap did — also stays correct under in-place merges (e.g. liteMerge).
  if (application instanceof entities.Application) {
    application.syntheticStatus = selectors.application.selectSyntheticApplicationStatus(application);
    return application as ChecklistApp;
  }

  const app: any = plainToInstance(entities.Application, application);
  app.syntheticStatus = selectors.application.selectSyntheticApplicationStatus(application);
  app._isLite = application._isLite;
  return app;
}
